var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-pixels"},[_c('el-row',[_c('el-col',[(_vm.aspId === '0')?_c('h2',[_vm._v("カート・計測システム連携のお申し込み")]):_c('h2',[_vm._v(_vm._s(_vm.aspData.aspName)+"のお申し込み")])])],1),_c('Tools02CartSystem',{attrs:{"aspId":_vm.aspId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }